(() => {
const root=window.Shopify?.routes?.root||'/';
const qs=s=>document.querySelector(s);
const toast=m=>{const t=qs('#LureToast');if(!t)return;t.textContent=m;t.classList.add('is-visible');setTimeout(()=>t.classList.remove('is-visible'),1800)};
async function refreshCart(){
  const r=await fetch(root+'cart.js'); const cart=await r.json();
  document.querySelectorAll('[data-cart-count]').forEach(e=>e.textContent=cart.item_count);
  const drawer=qs('#CartDrawer'); if(drawer){const html=await (await fetch(root+'?section_id=cart-drawer')).text(); const doc=new DOMParser().parseFromString(html,'text/html'); const next=doc.querySelector('#CartDrawer'); if(next)drawer.replaceWith(next);}
}
async function add(id,qty=1){
  const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty}]})});
  if(!r.ok)throw new Error(); await refreshCart(); qs('#CartDrawer')?.classList.add('is-open'); qs('.lure-overlay')?.classList.add('is-open'); toast('Added to bag');
}
document.addEventListener('click',e=>{
  const close=e.target.closest('[data-close-drawer]'); if(close){document.querySelectorAll('.is-open').forEach(x=>x.classList.remove('is-open'));return}
  const addBtn=e.target.closest('[data-add-to-cart]'); if(addBtn){e.preventDefault();add(addBtn.dataset.addToCart).catch(()=>toast('Please select an option'))}
  const cart=e.target.closest('[data-open-cart]'); if(cart){e.preventDefault();qs('#CartDrawer')?.classList.add('is-open');qs('.lure-overlay')?.classList.add('is-open')}
  const search=e.target.closest('[data-open-search]'); if(search){e.preventDefault();qs('#SearchDrawer')?.classList.add('is-open');qs('.lure-overlay')?.classList.add('is-open');setTimeout(()=>qs('#PredictiveSearchInput')?.focus(),80)}
  const menu=e.target.closest('[data-open-menu]'); if(menu){e.preventDefault();qs('#MobileMenu')?.classList.add('is-open');qs('.lure-overlay')?.classList.add('is-open')}
  const plus=e.target.closest('[data-qty-plus], [data-qty-minus]'); if(plus){const input=plus.parentElement.querySelector('input');let v=Math.max(0,Number(input.value)+(plus.hasAttribute('data-qty-plus')?1:-1));input.value=v;updateLine(input.dataset.line,v)}
});
async function updateLine(key,qty){
 const r=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
 if(r.ok){await refreshCart();}
}
let timer;
document.addEventListener('input',e=>{
 if(e.target.id!=='PredictiveSearchInput')return;
 clearTimeout(timer);const q=e.target.value.trim();const out=qs('#PredictiveSearchResults');if(!q){out.innerHTML='';return}
 timer=setTimeout(async()=>{try{
  const url=root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
  const r=await fetch(url); const data=await r.text(); const doc=new DOMParser().parseFromString(data,'text/html');
  const section=doc.querySelector('[data-predictive-results]'); if(section)out.innerHTML=section.innerHTML;
 }catch(err){}},180);
});
})();
document.addEventListener('click',e=>{if(e.target.closest('[data-filter-toggle]')){qs('#LureFilters')?.classList.toggle('is-open');qs('.lure-overlay')?.classList.toggle('is-open')}});

/* LURE PRODUCT GALLERY — carousel controls */
(() => {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const viewport = gallery.querySelector('[data-gallery-viewport]');
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  const current = gallery.querySelector('[data-gallery-current]');

  if (!track || slides.length < 2) return;

  let activeIndex = 0;
  let ticking = false;

  const setActive = (index, shouldScroll = true) => {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));

    if (shouldScroll) {
      const slide = slides[activeIndex];
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    thumbs.forEach((thumb, i) => {
      const active = i === activeIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (current) current.textContent = activeIndex + 1;

    if (prev) prev.disabled = activeIndex === 0;
    if (next) next.disabled = activeIndex === slides.length - 1;
  };

  const closestSlideIndex = () => {
    const left = track.scrollLeft;
    let closest = 0;
    let distance = Infinity;

    slides.forEach((slide, index) => {
      const distanceToSlide = Math.abs(slide.offsetLeft - left);
      if (distanceToSlide < distance) {
        distance = distanceToSlide;
        closest = index;
      }
    });

    return closest;
  };

  prev?.addEventListener('click', () => setActive(activeIndex - 1));
  next?.addEventListener('click', () => setActive(activeIndex + 1));

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      setActive(Number(thumb.dataset.galleryThumb));
    });
  });

  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const index = closestSlideIndex();
      if (index !== activeIndex) setActive(index, false);
      ticking = false;
    });
  }, { passive: true });

  let startX = 0;
  let startY = 0;

  viewport?.addEventListener('touchstart', (event) => {
    const touch = event.changedTouches[0];
    startX = touch.clientX;
    startY = touch.clientY;
  }, { passive: true });

  viewport?.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;

    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      setActive(activeIndex + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });

  setActive(0, false);
})();
